export const DColorType = wcardinal.ui.DColorType;